import type { ActionContext } from 'vuex'

import type { ActionClass, AuthState } from '../../../models'

import { AUTH_CONSTS } from '../../auth/auth.consts'

export class SetTokenAction implements ActionClass {
  static execute(this: void, { commit }: ActionContext<AuthState, any>, token: string): void {
    commit(AUTH_CONSTS.mutations.setState, {
      token,
    })
  }
}
